import React from 'react';

const Header = () => {
  return (
    <header className="bg-gray-800 text-white py-4 shadow-md">
      <div className="container mx-auto flex justify-between items-center px-4">
      <div class="site-logo">
				<a href="https://construlabs.com/" title="Construlabs USA" rel="home">
                    <img  class="header-image" alt="Construlabs USA" src="https://construlabs.com/wp-content/uploads/2020/04/ConstrulabsLogo.png" title="Construlabs USA" />
				</a>
			</div>
        <nav>
          <ul className="flex space-x-4">
            <li><a href="https://construlabs.com/precios/" className="hover:text-gray-400">Precios</a></li>
            <li><a href="https://construlabs.com/guias/" className="hover:text-gray-400">Guías</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
